// Exports
export default {
	"root": "root_ypmDo",
	"avatarWithNameBlock": "avatarWithNameBlock_AOhPP",
	"withoutName": "withoutName_CYi5e",
	"rootPresenterMini": "rootPresenterMini_cLZrn",
	"rootPresenter": "rootPresenter_Tj9H-",
	"rootModerator": "rootModerator_F9M6t",
	"participantName": "participantName_tl1zI",
	"rootModerationPopup": "rootModerationPopup_wSJps",
	"rootStroke": "rootStroke_Kb2PJ"
};
